export const WING_DIPPING = [
  {
    id: 1,
    name: 'Ranch',
    price: 0.75
  },
  {
    id: 2,
    name: 'Blue Cheese',
    price: 0.75
  },
];